<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import '@/assets/base.css';
import '@/assets/scss/main.scss';

export default {
  name: 'App',
  created() {
    fetch('/analyticsMapping.json')
      .then(response => response.json())
      .then(mapping => {
        const path = window.location.pathname; // e.g., "/du/en/"
        const segments = path.split('/').filter(Boolean);
        const countryCode = segments[0] ? segments[0].toLowerCase() : 'default';
        const languageCode = segments[1] ? segments[1].toLowerCase() : 'en';
  
        let config = mapping
            ? mapping[countryCode] || mapping.default
            : null;
        
        config['languageCode'] = languageCode;
        window.analyticsMapping = config;
      })
      .catch(err => {
        window.analyticsMapping = {
          default: {
            account: 'defaultAccount',
            currencyCode: 'USD'
          }
        };
      });
  },
}
</script>

<style>
</style>
